import React, { useState } from "react";
import "../Assets/Styles/form.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PromotionalEx = () => {
  const [formData, setFormData] = useState({
    sl: "",
    ph: "",
    body: "",
    heroUrl: "",
    ctaUrl: "",
    secondaryBannerUrl: "",
    trackingCode: "",
  });

  const [showPreview, setShowPreview] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    if (file) {
      // Get the file name (basename) without path
      const fileName = file.name;
      
      // Generate a URL for the uploaded file
      const fileUrl = URL.createObjectURL(file);
  
      // Set both the file name (basename) and the file URL
      setFormData({ ...formData, [name]: { fileName, fileUrl } });
    }
  };
  const heroFileName = formData.heroUrl?.fileName; // "banner.jpg"
const ctaFileName = formData.ctaUrl?.fileName; // "cta.jpg"
const secondaryBannerFileName = formData.secondaryBannerUrl?.fileName; // "secondary.jpg"


  const handleFormSubmit = (e) => {
    e.preventDefault();
    setShowPreview(true);
    saveAsHtmlFile();
  };

  const replaceFrenchCharacters = (text) => {
    const replacements = {
      é: "&eacute;",
      è: "&egrave;",
      ê: "&ecirc;",
      à: "&agrave;",
      ç: "&ccedil;",
      î: "&icirc;",
      ï: "&iuml;",
      ô: "&ocirc;",
      ù: "&ugrave;",
      û: "&ucirc;",
    };
    return text.replace(
      /[\u00E0-\u00FC]/g,
      (char) => replacements[char] || char
    );
  };

  const saveAsHtmlFile = async () => {
    const { sl, ph, body, heroUrl, ctaUrl, secondaryBannerUrl, trackingCode } =
      formData;

    const safeSl = replaceFrenchCharacters(sl);
    const safePh = replaceFrenchCharacters(ph);
    const safeBody = replaceFrenchCharacters(body);
    const fileName = trackingCode
      ? `${trackingCode.replace(/\s+/g, "_")}.html`
      : "Generated_email.html";

    const cvHtml = `
      <!DOCTYPE html>
      <html>
        <body>
          <h1>${safeSl}</h1>
          <p>${safePh}</p>
          <p>${safeBody}</p>
          <img src="${heroFileName}" alt="Hero Banner" />
          <a href="${ctaUrl}">CTA</a>
          <img src="${secondaryBannerUrl}" alt="Secondary Banner" />
        </body>
      </html>
    `;

    try {
      if (window.showSaveFilePicker) {
        const handle = await window.showSaveFilePicker({
          suggestedName: fileName,
          types: [
            {
              description: "HTML Files",
              accept: { "text/html": [".html"] },
            },
          ],
        });

        const writable = await handle.createWritable();
        await writable.write(cvHtml);
        await writable.close();
        toast.success("File saved successfully!");
      } else {
        const blob = new Blob([cvHtml], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
        toast.success("File saved successfully!");
      }
    } catch (error) {
      console.error("Error saving file:", error);
      toast.error("Failed to save the file!");
    }
  };

  return (
    <>
      <div className="container my-5">
        <div className="form-container">
          <h1 style={{ textAlign: "center" }}>Promotional Email</h1>
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6">
                <label>Sl</label>
                <input
                  type="text"
                  name="sl"
                  value={formData.sl}
                  onChange={handleInputChange}
                  placeholder="Sl"
                  required
                />
              </div>
              <div className="col-md-6">
                <label>ph</label>
                <input
                  type="text"
                  name="ph"
                  value={formData.ph}
                  onChange={handleInputChange}
                  placeholder="ph"
                  required
                />
              </div>
              <div className="col-md-6">
                <label>Tracking Code</label>
                <input
                  type="text"
                  name="trackingCode"
                  value={formData.trackingCode}
                  onChange={handleInputChange}
                  placeholder="Tracking Code"
                  required
                />
              </div>
              <div className="col-md-6">
                <label>Hero Banner</label>
                <input
                  type="file"
                  accept="image/*"
                  name="heroUrl"
                  onChange={handleFileChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <label>Body</label>
                <input
                  type="text"
                  name="body"
                  value={formData.body}
                  onChange={handleInputChange}
                  placeholder="Body"
                  required
                />
              </div>
              <div className="col-md-6">
                <label>Cta</label>
                <input
                  type="file"
                  accept="image/*"
                  name="ctaUrl"
                  onChange={handleFileChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <label>Secondary Banner</label>
                <input
                  type="file"
                  accept="image/*"
                  name="secondaryBannerUrl"
                  onChange={handleFileChange}
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              style={{
                width: "100%",
                margin: "10px 0",
                padding: "10px",
                fontWeight: "bold",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Generate Email
            </button>
          </form>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default PromotionalEx;
